import React from 'react';
import OrderCard from './OrderCard';
import FilterTabs from './FilterTabs';
import BatchActions from './BatchActions';

const FlexOrderList = ({ 
    orders, 
    selectedOrders, 
    onSelectOrder, 
    onSelectAll,
    currentFilter, 
    onFilterChange,
    onGenerateInvoices,
    onGenerateLabels,
    isLoading,
    processStatus 
}) => {
    // Filtros para FLEX
    const filters = {
        all: orders,
        withoutInvoice: orders.filter(o => !o.hasInvoice),
        withInvoice: orders.filter(o => o.hasInvoice && !o.hasLabel),
        readyToShip: orders.filter(o => o.hasInvoice && o.hasLabel)
    };

    const filteredOrders = filters[currentFilter] || filters.all;

    return (
        <div>
            {/* Tabs de Filtro */}
            <FilterTabs 
                filters={[
                    { id: 'all', label: 'Todos', count: filters.all.length },
                    { id: 'withoutInvoice', label: 'Sem Nota Fiscal', count: filters.withoutInvoice.length },
                    { id: 'withInvoice', label: 'Com Nota Fiscal', count: filters.withInvoice.length },
                    { id: 'readyToShip', label: 'Prontos para Envio', count: filters.readyToShip.length }
                ]}
                currentFilter={currentFilter}
                onChange={onFilterChange}
            />

            {/* Lista de Pedidos */}
            <div style={{ maxHeight: '60vh', overflowY: 'auto', marginTop: '20px' }}>
                {filteredOrders.map(order => (
                    <OrderCard 
                        key={order.id}
                        order={order}
                        selected={selectedOrders.includes(order.id)}
                        onSelect={onSelectOrder}
                        showInvoiceAction={true}
                        showLabelAction={true}
                    />
                ))}
            </div>

            {/* Status de Processamento */}
            {processStatus && (
                <div style={{
                    padding: '10px',
                    margin: '10px 0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '4px',
                    textAlign: 'center',
                    color: processStatus.includes('Erro') ? '#dc3545' : '#0d6efd'
                }}>
                    {processStatus}
                    {isLoading && (
                        <div className="loading-spinner" />
                    )}
                </div>
            )}

            {/* Ações em Lote */}
            <BatchActions
                selectedOrders={selectedOrders}
                filteredOrders={filteredOrders}
                onSelectAll={onSelectAll}
                onGenerateInvoices={onGenerateInvoices}
                onGenerateLabels={onGenerateLabels}
                isLoading={isLoading}
                currentFilter={currentFilter}
            />
        </div>
    );
};

export default FlexOrderList;